import React from 'react';
import PropTypes from 'prop-types';
import { Drawer as AntDrawer } from 'antd';
import cn from '../utils/cn';
import styles from './Drawer.module.css';

const Drawer = React.forwardRef(function Drawer(
  {
    open,
    onClose,
    title,
    placement = 'left',
    width = 'min(360px, 88vw)',
    children,
    className,
    ...rest
  },
  ref
) {
  return (
    <AntDrawer
      ref={ref}
      rootClassName={cn(styles.root, className)}
      open={open}
      onClose={onClose}
      title={title}
      placement={placement}
      width={width}
      {...rest}>
      {children}
    </AntDrawer>
  );
});

Drawer.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.node,
  placement: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
  className: PropTypes.string
};

export default Drawer;
